<template>
  <div v-if="confirmed">Your account has been confirmed. Please <RouterLink to="login">Login</RouterLink> now</div>
  <template v-else>
    <div v-if="confirmationToken">
      {{ confirmationToken }}
    </div>
    <div v-else>
      <div v-if="confirmationError">{{ confirmationError }}</div>
      <FormKit type="form" @submit="handleSubmit">
        <FormKit type="text" name="token" label="Confirmation Token"></FormKit>
      </FormKit>
    </div>
  </template>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { successNotification } from '@/utils/notifications'
import httpClient from '@/utils/httpClient'
const props = defineProps<{ token?: string }>()

const confirmationError = ref<string>()
const confirmed = ref(false)
const confirmationToken = ref(props.token)

onMounted(async () => {
  if (!confirmationToken.value) {
    return
  }
  await httpClient.get('/v1/accounts/confirmation', { params: { confirmation_token: confirmationToken.value } })
  confirmed.value = true
})

const handleSubmit = async (d: { token: string }) => {
  const response = await httpClient.get('/v1/accounts/confirmation', { params: { confirmation_token: d.token } })
  successNotification(response.data.message)
  confirmed.value = true
}
</script>
